/* Wrenfold — the one motion rule and the few bits of interaction the design needs.
   Reveal logic ported from the DCLogic script in "Wrenfold Home.dc.html". */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* fade + 14px rise, 650ms, stagger 90ms — see design-system.md "Motion"

     The observer is kept out here rather than inside the setup function so the
     facet swap can register the cards it just inserted. Nothing is hidden by
     CSS before the class lands, so an unregistered card is simply a card that
     did not animate — never a card nobody can see. */
  var revealObserver = null;

  function registerReveals() {
    if (!revealObserver) return;
    document.querySelectorAll('[data-reveal]:not(.wf-reveal)').forEach(function (el, i) {
      el.dataset.d = String(i % 4);
      revealObserver.observe(el);
    });
  }

  function watchReveals() {
    if (reduced || !('IntersectionObserver' in window)) return;
    revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.style.setProperty('--d', String(en.target.dataset.d || 0));
        en.target.classList.add('wf-reveal');
        revealObserver.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    registerReveals();
    setTimeout(registerReveals, 400);
  }

  function burger() {
    var btn = document.querySelector('[data-wf-burger]');
    var nav = document.getElementById('wf-nav');
    if (!btn || !nav) return;
    btn.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Drawer: <details> already opens, closes and takes focus on its own. These
     are the two behaviours it does not give you — Escape, and a click on the
     page behind. Nothing here is required for the menu to work. */
  function drawer() {
    var d = document.querySelector('[data-wf-drawer]');
    if (!d) return;
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && d.open) {
        d.open = false;
        var s = d.querySelector('summary');
        if (s) s.focus();
      }
    });
    d.addEventListener('click', function (e) {
      if (e.target.matches('[data-wf-drawer-scrim]')) d.open = false;
    });
  }

  /* product gallery: thumbnails swap the main image */
  /* The product gallery. Everything it does is an upgrade to behaviour the
     markup already has: the track is a scroll container, so swipe and the arrow
     keys work with this file absent, and the thumbnails are anchors to the
     slides, so they work too. This turns the anchor jump into a smooth scroll
     that does not add a history entry, and keeps aria-current pointing at
     whichever slide is actually on screen — including after a swipe, which no
     amount of click handling would have noticed. */
  function gallery() {
    var track = document.querySelector('[data-wf-gallery]');
    if (!track) return;
    var thumbs = [].slice.call(document.querySelectorAll('[data-wf-thumb]'));
    var slides = [].slice.call(track.querySelectorAll('[data-wf-slide]'));
    if (!slides.length) return;

    function show(index) {
      thumbs.forEach(function (t) {
        if (t.getAttribute('data-wf-thumb') === String(index)) {
          t.setAttribute('aria-current', 'true');
        } else {
          t.removeAttribute('aria-current');
        }
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function (e) {
        var slide = track.querySelector('[data-wf-slide="' + t.getAttribute('data-wf-thumb') + '"]');
        if (!slide) return;                       /* let the anchor do its job */
        e.preventDefault();
        /* block:'nearest' so scrolling the track sideways never drags the page
           up or down with it. */
        slide.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      });
    });

    if (!('IntersectionObserver' in window)) return;
    /* Half a slide visible is the threshold: the track snaps, so only one slide
       is ever past 50% of the viewport, and two thumbnails cannot light at once.
       Watching the slides rather than the clicks is what makes a swipe move the
       thumbnail — the case a click handler can never see. */
    var watcher = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) show(Number(en.target.getAttribute('data-wf-slide')));
      });
    }, { root: track, threshold: 0.5 });
    slides.forEach(function (s) { watcher.observe(s); });
  }

  function qty() {
    document.querySelectorAll('[data-wf-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = b.getAttribute('data-step') === 'down' ? -1 : 1;
          var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          if (next === (parseInt(input.value, 10) || 1)) return;
          input.value = next;
          /* Setting .value from script fires nothing, so on the basket the
             stepper would change the number and leave the cart untouched until
             somebody pressed "Update basket" — the button whose whole purpose
             is to not be needed. The product page input has no
             data-wf-autosubmit, so this event is ignored there. */
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* Delivery, returns and the FAQ are the pages people print, and a closed
     <details> prints as a heading with nothing under it. CSS cannot force one
     open in Chrome — display on the children does not reach the hidden slot —
     so the accordions are opened for the print job and put back afterwards. */
  function printableAccordions() {
    var opened = [];
    if (!window.matchMedia) return;
    var open = function () {
      opened = [].slice.call(document.querySelectorAll('details:not([open])'));
      opened.forEach(function (d) { d.open = true; });
    };
    var close = function () {
      opened.forEach(function (d) { d.open = false; });
      opened = [];
    };
    window.addEventListener('beforeprint', open);
    window.addEventListener('afterprint', close);
    /* Safari fires neither event; it flips this media query instead. */
    var mq = window.matchMedia('print');
    if (mq.addEventListener) {
      mq.addEventListener('change', function (e) { e.matches ? open() : close(); });
    }
  }

  /* ------------------------------------------------------------------------
     Filtering and paging without losing your place.

     A filter is a link to one of Shopify's tag URLs, so clicking one used to
     reload the page and drop you back at the top — a banner, a heading, a
     paragraph and the whole facet bar above the first product, 1113px of
     scrolling to get back to where you were looking. Paging was worse: a fresh
     load plus whatever offset the browser decided to restore, which lands you
     in the middle of somebody else's row.

     So: fetch the same URL, swap the two elements that changed, and control the
     scroll deliberately. The links stay links and the markup stays server-
     rendered, so with scripting off nothing here has changed.
     --------------------------------------------------------------------- */
  var facetSwap = null;

  function facets() {
    var shelf = document.getElementById('wf-shelf');
    var bar = document.getElementById('wf-facets');
    if (!shelf || !bar) return;                       /* not a shelf page */
    if (!window.fetch || !window.AbortController || !window.DOMParser) return;
    if (!window.history || !history.pushState) return;

    /* The section id is generated by Shopify and changes when the template is
       rebuilt, so it is read from the wrapper rather than written down. */
    var wrapper = shelf.closest('.shopify-section');
    if (!wrapper || wrapper.id.indexOf('shopify-section-') !== 0) return;
    var sectionId = wrapper.id.slice('shopify-section-'.length);

    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

    var parser = new DOMParser();
    var inflight = null;

    var sectionUrl = function (href) {
      var u = new URL(href, location.origin);
      u.searchParams.set('section_id', sectionId);
      return u.toString();
    };

    var publicUrl = function (href) {
      var u = new URL(href, location.origin);
      u.searchParams.delete('section_id');
      return u.pathname + u.search;
    };

    /* Which facet groups the visitor has collapsed. Re-rendering the bar would
       otherwise reopen every one of them on each click. */
    var openGroups = function () {
      var state = {};
      bar.querySelectorAll('.wf-facets__group').forEach(function (g) {
        var s = g.querySelector('.wf-facets__summary');
        if (s) state[s.textContent.trim()] = g.open;
      });
      return state;
    };

    var applyGroups = function (state) {
      document.querySelectorAll('#wf-facets .wf-facets__group').forEach(function (g) {
        var s = g.querySelector('.wf-facets__summary');
        var key = s && s.textContent.trim();
        if (key && key in state) g.open = state[key];
      });
    };

    var busy = function (on) {
      [document.getElementById('wf-facets'), document.getElementById('wf-shelf')]
        .forEach(function (el) {
          if (!el) return;
          el.classList.toggle('is-loading', on);
          if (on) el.setAttribute('aria-busy', 'true');
          else el.removeAttribute('aria-busy');
        });
    };

    /* mode: 'filter' holds the shelf still, 'page' puts the first card at the
       top of the screen, 'restore' (back/forward) touches nothing. */
    function go(href, mode) {
      if (inflight) inflight.abort();
      inflight = new AbortController();
      var signal = inflight.signal;
      var groups = openGroups();
      var anchor = document.getElementById('wf-shelf').getBoundingClientRect().top;
      var active = document.activeElement;
      var focusHref = active && active.getAttribute ? active.getAttribute('href') : null;
      var focusLabel = active && active.textContent ? active.textContent.trim() : null;
      busy(true);

      return fetch(sectionUrl(href), { signal: signal, headers: { 'X-Requested-With': 'fetch' } })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text().then(function (html) { return { html: html, url: res.url }; });
        })
        .then(function (out) {
          if (signal.aborted) return;
          var doc = parser.parseFromString(out.html, 'text/html');
          var nextBar = doc.getElementById('wf-facets');
          var nextShelf = doc.getElementById('wf-shelf');
          if (!nextShelf) throw new Error('no shelf in response');

          if (nextBar) document.getElementById('wf-facets').replaceWith(nextBar);
          document.getElementById('wf-shelf').replaceWith(nextShelf);
          bar = document.getElementById('wf-facets');
          applyGroups(groups);
          busy(false);
          registerReveals();

          /* Shopify 301s tag URLs into its own order — soap-flowers+for-her
             becomes for-her+soap-flowers — so the address bar takes the URL the
             response actually came from, not the one that was clicked. */
          var url = publicUrl(out.url);
          if (mode !== 'restore') history.pushState({ wf: 1 }, '', url);

          var shelfNow = document.getElementById('wf-shelf');
          if (mode === 'page') {
            /* The top of the results, not the top of the grid: landing on the
               first card alone leaves the count and the chips off screen, and
               page two is exactly when somebody wants to see "33 gifts" and
               reach for a filter. The banner and the intro stay above. */
            var head = document.getElementById('wf-facets') || shelfNow;
            var top = head.getBoundingClientRect().top + window.pageYOffset - 16;
            window.scrollTo({ top: top, behavior: reduced ? 'auto' : 'smooth' });
          } else if (mode !== 'restore') {
            /* Adding a filter inserts the "Filtering by" row above the grid.
               Without this the products slide down by its height, which is the
               jump this whole module exists to remove. */
            var delta = shelfNow.getBoundingClientRect().top - anchor;
            if (Math.abs(delta) > 1) window.scrollBy(0, delta);
          }

          /* Keyboard focus would land on <body> after replaceWith. Paging keeps
             it on Next or Previous — matched by label, because their hrefs move
             with the page number — so you can keep paging from the keyboard.
             Filtering keeps it on the same chip; when the chip you clicked was
             the one you just removed, the count is the landing spot. */
          var back = null;
          if (mode === 'page' && focusLabel) {
            back = [].slice.call(document.querySelectorAll('#wf-shelf .wf-pager a'))
              .filter(function (a) { return a.textContent.trim() === focusLabel; })[0];
          }
          if (!back && focusHref) {
            back = document.querySelector(
              '#wf-facets a[href="' + focusHref.replace(/"/g, '\\"') + '"]');
          }
          if (back) {
            back.focus({ preventScroll: true });
          } else if (mode !== 'restore') {
            var count = document.querySelector('.wf-facets__count');
            if (count) {
              count.setAttribute('tabindex', '-1');
              count.focus({ preventScroll: true });
            }
          }
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          /* Whatever went wrong, the visitor still gets where they were going. */
          location.assign(href);
        });
    }

    facetSwap = go;

    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
      if (a.origin !== location.origin) return;

      var mode = null;
      if (a.closest('#wf-facets')) mode = 'filter';
      else if (a.closest('#wf-shelf .wf-pager')) mode = 'page';
      else if (a.closest('#wf-shelf .wf-empty')) mode = 'filter';
      if (!mode) return;                      /* product links are left alone */

      e.preventDefault();
      go(a.href, mode);
    });

    window.addEventListener('popstate', function () {
      if (document.getElementById('wf-shelf')) go(location.href, 'restore');
    });
  }

  /* The collection sort control. The form works on its own — there is a submit
     button behind <noscript> — so this only removes the second click, and goes
     through the swap when the shelf is on screen so sorting keeps your place
     the same way filtering does.

     Delegated rather than bound to the element: the sort select lives inside
     the facet bar, so every filter click replaces it. Binding per element left
     the new select inert, which is a bug you only meet on the second
     interaction — filter once, then sorting silently does nothing. */
  function autosubmit() {
    document.addEventListener('change', function (e) {
      var select = e.target.closest && e.target.closest('[data-wf-autosubmit]');
      if (!select || !select.form) return;
      if (facetSwap) {
        var u = new URL(select.form.action, location.origin);
        new FormData(select.form).forEach(function (v, k) { u.searchParams.set(k, v); });
        facetSwap(u.toString(), 'filter');
        return;
      }
      select.form.submit();
    });
  }

  /* "Goes nicely with", answered by the shop rather than by the shelf order.
     The block is already filled server-side from the product's collection, so
     this only ever replaces a correct answer with a better one — if the fetch
     fails, is blocked, or returns nothing, what is on screen stays.

     It asks for the product section and keeps only .wf-related out of the
     reply. Recommendations live inside wf-main-product rather than in a section
     of their own, so the response is the whole product section; that is a
     heavier payload than a dedicated section would be, but it happens after
     load, off the critical path, and it avoids editing templates/product.json
     to add a section whose only job is four cards. */
  function recommendations() {
    var root = document.querySelector('[data-wf-recommendations]');
    if (!root || !window.fetch || !window.DOMParser) return;
    var url = root.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { if (!r.ok) throw new Error('recommendations ' + r.status); return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html')
          .querySelector('[data-wf-recommendations] .wf-grid');
        var grid = root.querySelector('.wf-grid');
        if (!fresh || !grid || !fresh.children.length) return;
        grid.innerHTML = fresh.innerHTML;
        /* registerReveals, not watchReveals: the new cards need to be handed to
           the observer that already exists. Building a second observer would
           leave the first one holding elements nobody unobserves. Nothing here
           is load-bearing — [data-reveal] has no opacity of its own, the class
           only adds an entrance animation — so a miss costs the animation and
           not the cards. */
        registerReveals();
      })
      .catch(function () { /* the server-rendered fallback is already correct */ });
  }

  /* Shows the phone buy bar exactly while the real Add to basket is off screen.
     Driven by an observer on the button itself rather than by a scroll offset:
     the offset would need re-measuring every time the description length or the
     variant picker changes, and it would be wrong on the first product whose
     copy runs long. */
  function stickyBuy() {
    var bar = document.querySelector('[data-wf-stickybuy]');
    var anchor = document.querySelector('.wf-pdp__buy button[type="submit"]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    bar.removeAttribute('hidden');
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-on', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -8px 0px' }).observe(anchor);
  }

  /* ========================================================================
     Wave four.

     Everything below is an upgrade to markup that already works without it.
     The rule the whole file is written to: if this asset fails to load, is
     blocked, or throws, the shop is exactly what it was — a header of links, a
     search page, forms that post to /cart/add and redirect. Nothing here is
     the only way to do anything.

     What it adds is the set of behaviours the paid themes installed beside
     this one have and this one did not: a header that stays reachable, search
     without leaving the page, a basket that opens over the page instead of
     replacing it, shelves with arrows, photographs that enlarge, and a trail
     back to what you were just looking at.
     ==================================================================== */

  /* --- shared -------------------------------------------------------- */

  /* Overlays nest: the drawer can be opened from the search panel. A boolean
     would unlock the page the moment the first of them closed. */
  var locks = 0;
  function lockScroll(on) {
    locks = Math.max(0, locks + (on ? 1 : -1));
    document.documentElement.classList.toggle('wf-locked', locks > 0);
  }

  var toastEl = null, toastTimer = null;
  function toast(message) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'wf-toast';
      /* status, not alert: this reports what happened, it does not interrupt. */
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    /* Force a frame so the transition runs when two toasts land back to back. */
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 4000);
  }

  /* Keeps Tab inside an open overlay. Without it the next Tab from a drawer
     lands on the page behind, which for a screen reader means the dialog has
     silently ended. */
  function trapFocus(root, onEscape) {
    function keys(e) {
      if (e.key === 'Escape') { e.preventDefault(); onEscape(); return; }
      if (e.key !== 'Tab') return;
      var f = [].slice.call(root.querySelectorAll(
        'a[href],button:not([disabled]),input:not([type="hidden"]),select,textarea,[tabindex]:not([tabindex="-1"])'
      )).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    document.addEventListener('keydown', keys);
    return function () { document.removeEventListener('keydown', keys); };
  }

  /* --- the header ---------------------------------------------------- */

  /* The section wrapper is what sticks — see the note in wf-header.liquid — so
     it is the element the state classes go on. Two measurements are published
     as custom properties because CSS elsewhere needs them and cannot measure:
     the announcement's height (how far the row scrolls before it sticks) and
     the row's height (what the filter bar and the product column sit under). */
  function header() {
    var head = document.querySelector('.wf-header');
    var wrap = head && head.closest('.shopify-section');
    if (!head || !wrap) return;
    var row = head.querySelector('.wf-header__row');
    var announce = head.querySelector('.wf-announce');
    var root = document.documentElement;

    function measure() {
      root.style.setProperty('--wf-announce-h', (announce ? announce.offsetHeight : 0) + 'px');
      if (row) root.style.setProperty('--wf-header-h', row.offsetHeight + 'px');
    }
    measure();
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(head);
    else window.addEventListener('resize', measure);

    var last = window.pageYOffset, ticking = false, wasStuck = null;
    function frame() {
      ticking = false;
      var y = Math.max(0, window.pageYOffset);
      /* The measured height, not a fresh read: measuring inside the scroll
         handler forces a layout on every frame, and the announcement's height
         does not change while the page is being scrolled. */
      var announceH = parseFloat(getComputedStyle(root).getPropertyValue('--wf-announce-h')) || 0;
      var stuck = y > announceH;
      wrap.classList.toggle('is-stuck', stuck);

      /* Hiding the row is only ever right while somebody is going down the
         page under their own steam. It must not happen while an overlay that
         lives inside the header is open — the search panel would go with it —
         and the 4px slack keeps a trackpad's jitter from flickering it. */
      var searchOpen = document.querySelector('[data-wf-searchpanel]:not([hidden])');
      if (searchOpen || y < 400) {
        wrap.classList.remove('is-hidden');
      } else if (y > last + 4) {
        wrap.classList.add('is-hidden');
      } else if (y < last - 4) {
        wrap.classList.remove('is-hidden');
      }
      last = y;
      /* Only when the row actually changed size — condensing it changes
         --wf-header-h, and the filter bar and the product column are pinned to
         that number. Re-measuring on every frame would be a layout per frame
         for a value that changes twice a page. */
      if (stuck !== wasStuck) { wasStuck = stuck; measure(); }
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(frame);
    }, { passive: true });
  }

  /* One announcement at a time. Paused while the tab is in the background —
     rotating a bar nobody is looking at wakes the machine up for nothing. */
  function announcements() {
    var bar = document.querySelector('[data-wf-announce]');
    if (!bar) return;
    var msgs = [].slice.call(bar.querySelectorAll('.wf-announce__msg'));
    if (msgs.length < 2) return;
    var seconds = parseInt(bar.getAttribute('data-seconds'), 10);
    if (!seconds || seconds < 3) seconds = 6;
    var i = 0, timer = null;
    function step() {
      msgs[i].classList.remove('is-on');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-on');
    }
    function start() { stop(); timer = setInterval(step, seconds * 1000); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    start();
    document.addEventListener('visibilitychange', function () {
      document.hidden ? stop() : start();
    });
    /* A message can be a link. Rotating it out from under the cursor is how
       somebody clicks the wrong one. */
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    bar.addEventListener('focusin', stop);
    bar.addEventListener('focusout', start);
  }

  /* --- search in place ------------------------------------------------ */

  function quickSearch() {
    var panel = document.querySelector('[data-wf-searchpanel]');
    var trigger = document.querySelector('[data-wf-search]');
    if (!panel || !trigger || !window.fetch) return;

    var input = panel.querySelector('[data-wf-searchinput]');
    var results = panel.querySelector('[data-wf-searchresults]');
    var closeBtn = panel.querySelector('[data-wf-searchclose]');
    var release = null, inflight = null, debounce = null, opener = null;

    function open() {
      if (!panel.hidden) return;
      opener = document.activeElement;
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      input.focus();
      release = trapFocus(panel, close);
      document.addEventListener('click', outside, true);
    }
    function close() {
      if (panel.hidden) return;
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      if (release) { release(); release = null; }
      document.removeEventListener('click', outside, true);
      if (opener && opener.focus) opener.focus();
    }
    function outside(e) {
      if (!panel.contains(e.target) && !trigger.contains(e.target)) close();
    }

    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', panel.id || 'wf-qs');
    trigger.addEventListener('click', function (e) {
      /* Modified clicks are somebody asking for a new tab of /search. Let them. */
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      e.preventDefault();
      panel.hidden ? open() : close();
    });
    if (closeBtn) closeBtn.addEventListener('click', close);

    function ask(term) {
      if (inflight) inflight.abort();
      if (!term || term.length < 2) { results.innerHTML = ''; return; }
      inflight = new AbortController();
      var url = '/search/suggest?q=' + encodeURIComponent(term) +
        '&section_id=wf-predictive-search' +
        '&resources[type]=product,collection,article&resources[limit]=6';
      fetch(url, { signal: inflight.signal })
        .then(function (r) { if (!r.ok) throw new Error('suggest ' + r.status); return r.text(); })
        .then(function (html) {
          /* The reply is the section wrapped in its own div; only the inside of
             it is wanted, and an empty reply means the section rendered
             nothing — leave the panel as it was rather than blanking it. */
          var doc = new DOMParser().parseFromString(html, 'text/html');
          /* The reply is the section inside its own wrapper div. Unwrap it if
             the wrapper is there and take the body if it is not — the shape of
             that reply is Shopify's to change, and either is a valid answer. */
          var frag = doc.querySelector('.shopify-section') || doc.body;
          /* An empty render means the term produced no section at all, which is
             different from producing a no-matches note. Blanking the panel is
             the honest response to it. */
          results.innerHTML = frag.innerHTML.trim();
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          /* The form behind is a real GET to /search; say so rather than
             leaving a box that looks broken. */
          results.innerHTML = '<p class="wf-qs__note">Suggestions are not loading. ' +
            'Press Enter to search the whole shop.</p>';
        });
    }

    input.addEventListener('input', function () {
      clearTimeout(debounce);
      var term = input.value.trim();
      debounce = setTimeout(function () { ask(term); }, 220);
    });
  }

  /* --- the basket drawer --------------------------------------------- */

  function cartDrawer() {
    var el = document.querySelector('[data-wf-cart-drawer]');
    if (!el || !window.fetch || !window.DOMParser) return;

    var wrap = el.closest('.shopify-section');
    if (!wrap || wrap.id.indexOf('shopify-section-') !== 0) return;
    /* Same trick the facet swap uses: the section id is generated by Shopify
       and changes when the group is rebuilt, so it is read rather than typed. */
    var sectionId = wrap.id.slice('shopify-section-'.length);
    var release = null, opener = null;

    function node() { return document.querySelector('[data-wf-cart-drawer]'); }

    function open() {
      var d = node();
      if (!d || d.classList.contains('is-open')) return;
      opener = document.activeElement;
      d.hidden = false;
      /* A frame between display and the class, or the panel is already at rest
         when the transition is asked to run it. */
      requestAnimationFrame(function () { d.classList.add('is-open'); });
      lockScroll(true);
      release = trapFocus(d, close);
      var first = d.querySelector('[data-wf-cd-close]');
      if (first) first.focus();
    }

    function close() {
      var d = node();
      if (!d || !d.classList.contains('is-open')) return;
      d.classList.remove('is-open');
      lockScroll(false);
      if (release) { release(); release = null; }
      var done = function () { if (!d.classList.contains('is-open')) d.hidden = true; };
      if (reduced) done(); else setTimeout(done, 650);
      if (opener && opener.focus) opener.focus();
    }

    /* Re-render from Liquid rather than patching the DOM by hand. Every number
       in the drawer — line totals, the delivery threshold, the subtotal — is
       arithmetic the basket page also does, and doing it twice in two languages
       is how the two stop agreeing. */
    function refresh() {
      return fetch(location.pathname + '?sections=' + encodeURIComponent(sectionId), {
        headers: { 'X-Requested-With': 'fetch' }
      })
        .then(function (r) { if (!r.ok) throw new Error('sections ' + r.status); return r.json(); })
        .then(function (data) {
          var html = data[sectionId];
          if (!html) throw new Error('section missing from reply');
          var fresh = new DOMParser().parseFromString(html, 'text/html')
            .querySelector('[data-wf-cart-drawer]');
          if (!fresh) throw new Error('drawer missing from reply');
          var current = node();
          var wasOpen = current.classList.contains('is-open');
          fresh.hidden = current.hidden;
          if (wasOpen) fresh.classList.add('is-open');
          current.replaceWith(fresh);
          count(fresh.getAttribute('data-count'));
        });
    }

    function count(n) {
      var badge = document.querySelector('[data-wf-cart-count]');
      var link = badge && badge.closest('a');
      var total = parseInt(n, 10) || 0;
      if (badge) {
        badge.textContent = total;
        badge.hidden = total === 0;
      }
      if (link) {
        var label = total === 0 ? 'Basket'
          : 'Basket, ' + total + ' ' + (total === 1 ? 'item' : 'items');
        link.setAttribute('aria-label', label);
        link.setAttribute('title', label);
      }
    }

    /* The bag in the header. Still an anchor to /cart underneath. */
    document.addEventListener('click', function (e) {
      var bag = e.target.closest && e.target.closest('[data-wf-cart-open]');
      if (bag) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        e.preventDefault();
        refresh().then(open).catch(function () { location.assign(bag.href); });
        return;
      }
      var closer = e.target.closest && e.target.closest('[data-wf-cd-close]');
      if (closer) {
        /* The empty state's "Shop gift boxes" carries this attribute too, and it
           is a link: it should close the drawer *and* go where it points. Only
           the buttons — the X and the scrim — swallow the click. */
        if (closer.tagName !== 'A') e.preventDefault();
        close();
      }
    });

    /* Every add-to-basket form on the shop, wherever it is and whenever it was
       inserted. Matched on the action rather than on a data attribute so a form
       rendered by a section this file has never heard of is still caught. */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      e.preventDefault();
      var button = form.querySelector('[type="submit"]');
      var label = button ? button.innerHTML : '';
      if (button) { button.classList.add('is-busy'); button.setAttribute('aria-busy', 'true'); }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'fetch' },
        body: new FormData(form)
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data.description || data.message || 'That could not be added.');
            return data;
          });
        })
        .then(function () { return refresh(); })
        .then(function () { open(); })
        .catch(function (err) {
          /* Sold out between the page loading and the click is the ordinary
             case here, and Shopify's own wording for it is the honest one. */
          toast(err && err.message ? err.message : 'That could not be added.');
        })
        .then(function () {
          if (!button) return;
          button.classList.remove('is-busy');
          button.removeAttribute('aria-busy');
          button.innerHTML = label;
        });
    });

    /* Quantity and remove inside the drawer. Delegated, because refresh()
       replaces the whole element and anything bound per-node would be inert
       from the second interaction onwards — the bug this file already learned
       once on the collection sort control. */
    function change(key, quantity) {
      var d = node();
      if (d) d.classList.add('is-loading');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { if (!r.ok) throw new Error('change ' + r.status); return r.json(); })
        .then(function () { return refresh(); })
        .catch(function () {
          toast('The basket could not be updated. Opening it in full.');
          location.assign('/cart');
        });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-wf-cart-drawer] [data-key]');
      if (!btn || btn.tagName !== 'BUTTON') return;
      e.preventDefault();
      change(btn.getAttribute('data-key'), parseInt(btn.getAttribute('data-qty'), 10) || 0);
    });

    document.addEventListener('change', function (e) {
      var input = e.target.closest && e.target.closest('[data-wf-cart-drawer] input[data-key]');
      if (!input) return;
      var n = parseInt(input.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      change(input.getAttribute('data-key'), n);
    });

    /* The stepper buttons inside the drawer carry their own target quantity in
       data-qty, so the generic qty() handler must not also fire on them — it
       does not: it binds to [data-wf-qty] and these are [data-wf-cd-qty]. */
  }

  /* --- shelves: arrows and a progress line ---------------------------- */

  function shelves() {
    document.querySelectorAll('[data-wf-shelftrack]').forEach(function (track) {
      var section = track.closest('section') || document;
      var nav = section.querySelector('[data-wf-shelfnav]');
      var progress = section.querySelector('[data-wf-shelfprogress]');
      var fill = progress && progress.querySelector('.wf-shelf__progressfill');

      /* Nothing to scroll: a shelf of three cards on a wide screen. Leaving the
         arrows would give two permanently dead controls. */
      function scrollable() { return track.scrollWidth - track.clientWidth > 4; }

      function paint() {
        if (!scrollable()) {
          if (nav) nav.hidden = true;
          if (progress) progress.hidden = true;
          return;
        }
        if (nav) nav.hidden = false;
        if (progress) progress.hidden = false;
        var max = track.scrollWidth - track.clientWidth;
        var pct = max > 0 ? (track.scrollLeft / max) * 100 : 0;
        if (fill) fill.style.width = Math.max(6, Math.min(100, pct)) + '%';
        if (nav) {
          var prev = nav.querySelector('[data-wf-shelf="prev"]');
          var next = nav.querySelector('[data-wf-shelf="next"]');
          if (prev) prev.disabled = track.scrollLeft < 4;
          if (next) next.disabled = track.scrollLeft > max - 4;
        }
      }

      if (nav) {
        nav.addEventListener('click', function (e) {
          var b = e.target.closest('[data-wf-shelf]');
          if (!b) return;
          var step = Math.max(240, Math.round(track.clientWidth * 0.8));
          track.scrollBy({
            left: b.getAttribute('data-wf-shelf') === 'prev' ? -step : step,
            behavior: reduced ? 'auto' : 'smooth'
          });
        });
      }

      track.addEventListener('scroll', function () {
        requestAnimationFrame(paint);
      }, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(paint).observe(track);
      else window.addEventListener('resize', paint);
      paint();
    });
  }

  /* --- the product photographs, full size ----------------------------- */

  function lightbox() {
    var track = document.querySelector('[data-wf-gallery]');
    if (!track) return;
    var slides = [].slice.call(track.querySelectorAll('[data-wf-zoom]'));
    if (!slides.length) return;

    var openBtn = document.querySelector('[data-wf-zoomopen]');
    if (openBtn) openBtn.hidden = false;

    var box = null, img = null, counter = null, release = null, opener = null, at = 0;

    function build() {
      box = document.createElement('div');
      box.className = 'wf-lb';
      box.hidden = true;
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.setAttribute('aria-label', 'Product photograph, full size');
      box.innerHTML =
        '<img class="wf-lb__img" alt="">' +
        '<button type="button" class="wf-iconbtn wf-iconbtn--md wf-lb__close" aria-label="Close">' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
        'stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg></button>' +
        '<button type="button" class="wf-iconbtn wf-iconbtn--md wf-lb__nav wf-lb__nav--prev" aria-label="Previous photograph">' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
        'stroke-linecap="round" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg></button>' +
        '<button type="button" class="wf-iconbtn wf-iconbtn--md wf-lb__nav wf-lb__nav--next" aria-label="Next photograph">' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
        'stroke-linecap="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg></button>' +
        '<span class="wf-lb__count"></span>';
      document.body.appendChild(box);
      img = box.querySelector('.wf-lb__img');
      counter = box.querySelector('.wf-lb__count');
      box.addEventListener('click', function (e) {
        if (e.target === box) { close(); return; }
        if (e.target.closest('.wf-lb__close')) { close(); return; }
        if (e.target.closest('.wf-lb__nav--prev')) { show(at - 1); return; }
        if (e.target.closest('.wf-lb__nav--next')) { show(at + 1); }
      });
      /* Only the two arrow keys, and only while it is open. */
      box.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(at - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); show(at + 1); }
      });
      if (slides.length < 2) {
        box.querySelectorAll('.wf-lb__nav').forEach(function (b) { b.hidden = true; });
      }
    }

    function show(i) {
      at = (i + slides.length) % slides.length;
      img.src = slides[at].getAttribute('data-wf-zoom');
      img.alt = slides[at].getAttribute('data-wf-zoom-alt') || '';
      if (counter) counter.textContent = (at + 1) + ' of ' + slides.length;
    }

    /* Which photograph is on screen in the track right now — the same answer
       the thumbnails show, so opening the lightbox never jumps to a different
       picture from the one being looked at. */
    function current() {
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = 0, dist = Infinity;
      slides.forEach(function (s, i) {
        var c = s.offsetLeft + s.offsetWidth / 2;
        var d = Math.abs(c - mid);
        if (d < dist) { dist = d; best = i; }
      });
      return best;
    }

    function open(i) {
      if (!box) build();
      opener = document.activeElement;
      show(i);
      box.hidden = false;
      requestAnimationFrame(function () { box.classList.add('is-open'); });
      lockScroll(true);
      release = trapFocus(box, close);
      box.querySelector('.wf-lb__close').focus();
    }

    function close() {
      if (!box || box.hidden) return;
      box.classList.remove('is-open');
      box.hidden = true;
      lockScroll(false);
      if (release) { release(); release = null; }
      if (opener && opener.focus) opener.focus();
    }

    if (openBtn) openBtn.addEventListener('click', function () { open(current()); });

    /* Clicking the photograph itself, on pointer devices. On a touch screen a
       tap on the slide is how somebody stops a swipe, so it is left alone. */
    if (window.matchMedia('(hover:hover)').matches) {
      track.addEventListener('click', function (e) {
        var slide = e.target.closest('[data-wf-zoom]');
        if (!slide) return;
        open(slides.indexOf(slide));
      });
    }
  }

  /* --- recently viewed ------------------------------------------------ */

  var VIEWED_KEY = 'wf:viewed';

  function readViewed() {
    try {
      var raw = localStorage.getItem(VIEWED_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      /* Private mode, a full quota, or somebody else's JSON under our key.
         An empty trail is a correct answer; a thrown error is not. */
      return [];
    }
  }

  function writeViewed(list) {
    try { localStorage.setItem(VIEWED_KEY, JSON.stringify(list.slice(0, 12))); }
    catch (e) { /* nothing to do and nothing lost */ }
  }

  function recordViewed() {
    var tag = document.querySelector('script[data-wf-viewed]');
    if (!tag) return;
    var item;
    try { item = JSON.parse(tag.textContent); } catch (e) { return; }
    if (!item || !item.handle) return;
    var list = readViewed().filter(function (p) { return p && p.handle !== item.handle; });
    list.unshift(item);
    writeViewed(list);
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function renderViewed() {
    var section = document.querySelector('[data-wf-recent]');
    if (!section) return;
    var list = section.querySelector('[data-wf-recent-list]');
    var clear = section.querySelector('[data-wf-recent-clear]');
    var keep = parseInt(section.getAttribute('data-wf-recent'), 10) || 8;
    var here = document.querySelector('script[data-wf-viewed]');
    var skip = null;
    if (here) { try { skip = JSON.parse(here.textContent).handle; } catch (e) { skip = null; } }

    var items = readViewed().filter(function (p) {
      return p && p.handle && p.handle !== skip;
    }).slice(0, keep);

    if (!items.length) { section.hidden = true; return; }

    list.innerHTML = items.map(function (p) {
      var media = p.image
        ? '<img class="wf-card__img" src="' + esc(p.image) + '" alt="' + esc(p.alt || p.title) +
          '" loading="lazy" decoding="async" width="700" height="875">'
        : '<span class="wf-card__ph">photo to come</span>';
      /* The variant id was captured from the same page the price was, so the
         add posts the thing whose price is on the card. Products that were
         unavailable when they were seen get no button rather than a button
         that fails — the drawer would report it, but after the click. */
      var add = (p.available && p.variant)
        ? '<form class="wf-card__quick" action="/cart/add" method="post" enctype="multipart/form-data">' +
          '<input type="hidden" name="id" value="' + esc(p.variant) + '">' +
          '<input type="hidden" name="quantity" value="1">' +
          '<button type="submit" class="wf-btn wf-btn--inverse wf-btn--sm wf-card__quickbtn">' +
          '<span>Add · ' + esc(p.price) + '</span></button></form>'
        : '';
      return '<div class="wf-shelf__item"><div class="wf-card">' +
        '<div class="wf-card__media">' + media + add + '</div>' +
        '<div class="wf-card__text">' +
        (p.collection ? '<span class="wf-card__collection">' + esc(p.collection) + '</span>' : '') +
        '<a class="wf-card__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<span class="wf-card__price">' + esc(p.price) + '</span>' +
        '</div></div></div>';
    }).join('');

    section.hidden = false;

    if (clear) {
      clear.addEventListener('click', function () {
        try { localStorage.removeItem(VIEWED_KEY); } catch (e) { /* nothing to clear */ }
        section.hidden = true;
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    watchReveals();
    burger();
    drawer();
    gallery();
    qty();
    recommendations();
    stickyBuy();
    printableAccordions();
    facets();      /* before autosubmit: it decides whether sorting swaps or reloads */
    autosubmit();
    header();
    announcements();
    quickSearch();
    cartDrawer();
    shelves();
    lightbox();
    recordViewed();  /* before renderViewed, so this page is excluded from its own trail */
    renderViewed();
  });
})();
